import { makeStyles, tokens } from "../shared";

export const avatarStyles = makeStyles({
  root: {
    fontWeight: tokens.fontWeightRegular,
  },
});
